/**
 * Helper function to count all steps including substeps within SWITCH/REPEAT blocks
 * @param steps - Array of step objects
 * @returns Total count of steps including substeps
 */
export const countAllSteps = (steps: any[]): number => {
  if (!steps) return 0;
  let count = 0;
  steps.forEach((step) => {
    count++; // Count the step itself
    // If it's a SWITCH/REPEAT step with substeps, count those too
    if (step.stepData?.stepsIds && typeof step.stepData.stepsIds === 'string') {
      const substepIds = step.stepData.stepsIds.split(',').filter((id: string) => id && id !== 'undefined');
      count += substepIds.length;
    }
  });
  console.log('COUNT', count);
  return count;
};
